import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0.001, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span initial="hide" {...trigger} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hide: { y: "105%" }, show: { y: "0%" } }}
            transition={{ duration: 1.1, delay: delay + i * 0.12, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <span className={`inline-flex items-center gap-3 font-mono-x text-xs uppercase tracking-[0.22em] ${light ? "text-brass" : "text-[var(--brass-deep)]"} ${className}`}>
    <span className={`h-px w-8 ${light ? "bg-brass" : "bg-[var(--brass-deep)]"}`} />
    {children}
  </span>
);
